(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["dezire-everyday-home"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-dezire-home]').forEach((root) => {
    if (root.dataset.enhanced === 'true') return;
    root.dataset.enhanced = 'true';

    const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
    const motionItems = Array.from(root.querySelectorAll('.dezire-category, .dezire-editorial, .dezire-services > div'));
    motionItems.forEach((item, index) => {
      item.classList.add('dezire-motion-item');
      item.style.setProperty('--motion-delay', `${(index % 6) * 55}ms`);
    });

    if (reduceMotion.matches || !('IntersectionObserver' in window)) {
      motionItems.forEach((item) => item.classList.add('is-visible'));
    } else {
      root.classList.add('motion-ready');
      const observer = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting) return;
          entry.target.classList.add('is-visible');
          observer.unobserve(entry.target);
        });
      }, { threshold: 0.12, rootMargin: '0px 0px -6% 0px' });
      motionItems.forEach((item) => observer.observe(item));
    }

  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
